var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "loginForm", staticClass: "login-form" }, [
    _c("div", {
      staticClass: "logo",
      domProps: { innerHTML: _vm._s(_vm.logo) },
    }),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "form",
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.onFormSubmit($event)
          },
        },
      },
      [
        _c("div", { staticClass: "messages" }, [
          _c(
            "div",
            { staticClass: "message error", class: { show: _vm.showMessage } },
            [
              _c("i", {
                staticClass: "fa fa-times",
                on: {
                  click: function ($event) {
                    return _vm.closeMessage()
                  },
                },
              }),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-exclamation-circle indicator" }),
              _vm._v(" "),
              _c("div", { staticClass: "message-inner" }, [
                _c("span", [_vm._v(_vm._s(_vm.errorMessage))]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "message info", class: { show: _vm.showInfo } },
            [
              _c("i", {
                staticClass: "fa fa-times",
                on: {
                  click: function ($event) {
                    return _vm.closeMessage()
                  },
                },
              }),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-exclamation-circle indicator" }),
              _vm._v(" "),
              _c("div", { staticClass: "message-inner" }, [
                _c("span", [_vm._v(_vm._s(_vm.errorMessage))]),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.displayWarning
          ? _c("div", {
              staticClass: "alert alert-warning mb-3",
              domProps: { innerHTML: _vm._s(_vm.$t("general_warning")) },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-row row" }, [
          _c("i", { staticClass: "fa fa-user" }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.lazy",
                value: _vm.user.login,
                expression: "user.login",
                modifiers: { lazy: true },
              },
            ],
            staticClass: "form-input col",
            attrs: {
              id: "username",
              name: "username",
              type: "text",
              placeholder: _vm.placeholders.login,
            },
            domProps: { value: _vm.user.login },
            on: {
              change: function ($event) {
                return _vm.$set(_vm.user, "login", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-row row" }, [
          _c("i", { staticClass: "fa fa-lock" }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.lazy",
                value: _vm.user.password,
                expression: "user.password",
                modifiers: { lazy: true },
              },
            ],
            staticClass: "form-input col",
            attrs: {
              id: "password",
              name: "password",
              type: "password",
              placeholder: _vm.placeholders.password,
            },
            domProps: { value: _vm.user.password },
            on: {
              change: function ($event) {
                return _vm.$set(_vm.user, "password", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _vm.devMode
          ? _c("div", { staticClass: "form-row row" }, [
              _c("i", { staticClass: "fa fa-code" }),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.api,
                      expression: "api",
                      modifiers: { lazy: true },
                    },
                  ],
                  staticClass: "form-input col",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.api = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v("Choisir une API"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.apiOptions, function (routeConfig) {
                    return _c(
                      "option",
                      {
                        key: routeConfig.index,
                        domProps: { value: routeConfig.route },
                      },
                      [
                        _vm._v(
                          "API de\n          " +
                            _vm._s(routeConfig.label) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "Btn",
          {
            class: "default block",
            attrs: { id: "connexion", btnType: "submit" },
            nativeOn: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.onFormSubmit($event)
              },
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("login.loginBtn")) + "\n    ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "login-separator" }, [
          _c("hr"),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("global.or")))]),
        ]),
        _vm._v(" "),
        _c(
          "Btn",
          {
            class: "google block",
            attrs: { btnType: "button" },
            nativeOn: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.onGoogleLogin($event)
              },
            },
          },
          [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.googleLogo) } }),
            _vm._v(
              "\n      " + _vm._s(_vm.$t("login.googleLoginBtn")) + "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "Btn",
          {
            class: "microsoft block",
            attrs: { btnType: "button" },
            nativeOn: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.onMicrosoftLogin($event)
              },
            },
          },
          [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.microsoftLogo) } }),
            _vm._v(
              "\n      " + _vm._s(_vm.$t("login.microsoftLoginBtn")) + "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
          attrs: { type: "submit" },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "center password-lost" },
          [
            _c(
              "Btn",
              {
                class: [{ "force-hover": _vm.passwordLostShow }],
                attrs: { id: "lostPassword" },
                nativeOn: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onPasswordLost($event)
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("login.passwordLost")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "password-lost-popover",
                class: { show: _vm.passwordLostShow },
              },
              [
                _c("i", {
                  staticClass: "fa fa-times",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.closePasswordLost($event)
                    },
                  },
                }),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.$t("login.explainPasswordLost")))]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("i", { staticClass: "fa fa-user" }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.loginForgetPassword,
                          expression: "loginForgetPassword",
                        },
                      ],
                      staticClass: "form-input",
                      attrs: {
                        type: "text",
                        id: "usernameForget",
                        name: "usernameForget",
                        placeholder: _vm.placeholders.loginLostPassword,
                      },
                      domProps: { value: _vm.loginForgetPassword },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.loginForgetPassword = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-2" },
                    [
                      _c(
                        "Btn",
                        {
                          class: "icon pull-right",
                          nativeOn: {
                            click: function ($event) {
                              return _vm.requestPasswordLost($event)
                            },
                          },
                        },
                        [_c("i", { staticClass: "fa fa-arrow-circle-right" })]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }